import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

const PlantationManagement = lazy(() =>
  import('@repo/ui/features/plantations/index').then((mod) => ({ default: mod.PlantationManagement })),
);

export default function PlantationsPage() {
  return (

    <Suspense fallback={<DendromapLoader message="Chargement des plantations..." />}>
      <PlantationManagement />
    </Suspense>

  );
}
